const Style = ({ attributes, clientId }) => {
	const { navBGColor, titleColor, remainingTimeColor, stepsBG } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		#stpContent-${clientId}{
			margin-top: 0;
			margin-bottom: 0;
		}
		#stpContent-${clientId} .stpContent{
			height: 800px;
		}
		#stpContent-${clientId} .stpNav{
			background: ${navBGColor};
		}
		#stpContent-${clientId} .stpNav h2{
			color: ${titleColor};
		}
		#stpContent-${clientId} .stpNav .remainingTime{
			color: ${remainingTimeColor};
		}
		#stpContent-${clientId} .stpSection{
			${stepsBG?.styles || 'background: #f8f9fa;'};
		}
	`}} />;
}
export default Style;